












































































import { Component, Emit, Model, Prop } from "vue-property-decorator";
import Vue from "vue";
import { VisibilityDefinition } from "@/api/model/VisibilityDefinition";
import ConfirmationDialog from "@/components/common/ConfirmationDialog.vue";

@Component({
    components: {ConfirmationDialog}
})
export default class ViewpointFactorVisibilityEditor extends Vue {

    CONDITIONAL_FUNCTIONS = [
        {
            value: "ALL_EXISTS",
            text: 'All contain values'
        },
        {
            value: "ANY_EXISTS",
            text: 'Any contain values'
        },
        {
            value: "NONE_EXISTS",
            text: 'None contain values'
        }
    ]

    @Model('updated:value')
    value!: VisibilityDefinition;

    @Prop()
    factors!: any[]

    @Prop()
    title!: string;

    @Prop()
    loading!: boolean;

    @Prop({default: '', type: String})
    viewpointName!: string;

    @Emit('updated:value')
    @Emit()
    private submit() {
        return this.value;
    }

    @Emit()
    private cancel() {

    }

    private getViewpointName(){
        if (this.viewpointName){
            return "Factor Visibillity for " + this.viewpointName;
        } else {
            return "Viewpoint Factor Visibility";
        }    
    }
}
